import {apolloClient} from '@/setup/apollo-setup';
import {error} from '@/utils/notification';
import {
  GET_ZONEGROUPS,
} from '@/queries/modules/common-data/zoneGroup';

export async function getZoneGroups(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_ZONEGROUPS,
        // fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setSuccess', null);
      return data.getZoneGroups
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}


